import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtINR, fmtDate } from "@/lib/api";
import { ArrowRight, Plus, MagnifyingGlass } from "@phosphor-icons/react";

export default function Invoices() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    const { data } = await api.get("/invoices");
    setRows(data);
  };
  useEffect(() => { load(); }, []);

  const filtered = rows.filter(
    (r) => !q || r.invoice_no.toLowerCase().includes(q.toLowerCase()) ||
           r.customer_snapshot?.name?.toLowerCase().includes(q.toLowerCase())
  );

  const statusClass = (s) =>
    s === "paid" ? "lb-badge-success" : s === "partial" ? "lb-badge-warning" : "lb-badge-danger";

  return (
    <div className="space-y-5 lb-fade" data-testid="invoices-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Sales</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Invoices</h1>
        </div>
        <Link to="/app/invoices/new" className="lb-btn" data-testid="new-invoice-btn">
          <Plus size={14} /> New Invoice
        </Link>
      </div>

      <div className="lb-card">
        <div className="p-3 border-b border-neutral-200 flex items-center gap-2">
          <MagnifyingGlass size={14} className="text-neutral-500" />
          <input placeholder="Search invoice or customer" value={q} onChange={(e) => setQ(e.target.value)}
                 className="bg-transparent outline-none text-sm flex-1" data-testid="invoice-search" />
        </div>
        <table className="lb-table">
          <thead>
            <tr>
              <th>Invoice #</th><th>Date</th><th>Customer</th><th>GSTIN</th>
              <th className="text-right">Amount</th><th>Status</th><th>e-Invoice</th><th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id} data-testid={`invoice-row-${r.invoice_no}`}>
                <td className="font-mono text-xs">{r.invoice_no}</td>
                <td className="text-sm">{fmtDate(r.invoice_date)}</td>
                <td className="text-sm">{r.customer_snapshot?.name}</td>
                <td className="font-mono text-xs text-neutral-600">{r.customer_snapshot?.gstin || "—"}</td>
                <td className="amt">{fmtINR(r.total)}</td>
                <td><span className={"lb-badge " + statusClass(r.status)}>{r.status}</span></td>
                <td>
                  <span className={"lb-badge " + (
                    r.einvoice_status === "generated" ? "lb-badge-info" :
                    r.einvoice_status === "cancelled" ? "lb-badge-danger" :
                    r.einvoice_status === "not_applicable" ? "" : "lb-badge-warning"
                  )}>{r.einvoice_status}</span>
                </td>
                <td>
                  <Link to={`/app/invoices/${r.id}`} className="text-[#0A66C2] font-semibold text-sm inline-flex items-center gap-1"
                        data-testid={`view-${r.invoice_no}`}>
                    View <ArrowRight size={12} />
                  </Link>
                </td>
              </tr>
            ))}
            {!filtered.length && (
              <tr><td colSpan={8} className="text-center py-10 text-neutral-500">No invoices yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
